import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'app-banner-message',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './banner-message.component.html',
  styleUrls: ['./banner-message.component.scss'],
  standalone: false,
})
export class BannerMessageComponent {
  @Input() message: string;

  @Input() status: string = 'warning'; // 'success'
}
